var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpoon02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{fill:#fff}.st1{fill:none;stroke:#000;stroke-width:50;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654 941.7c-33.4 39.1-88.2 87.8-211 89.3-153.1 1.9-216.6-158.1-223.1-175.8 15.9 25.6 101.2 60.2 207.4 82.3 112.5 23.5 208.9 24.8 226.7 4.2zm-226.7-4.2c112.5 23.5 209 24.7 226.7 4.2 1.4-1.6 2.3-3.3 2.7-5.2 5.4-25.9-88.5-67.3-209.8-92.6-121.3-25.3-224-24.8-229.4 1.1-.7 3.2.2 6.7 2.5 10.3 15.8 25.6 101.1 60.1 207.3 82.2z",
    id: "Layer_3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STROKES"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1701 1037L895 871c-138-32-178-2-214 38-7.8 8.7-16.3 20.2-27 32.7-33.4 39.1-88.2 87.7-211 89.3-153.1 1.9-216.6-158.1-223.1-175.8-.4-1-.6-1.6-.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.9 855.2c-2.3-3.6-3.1-7.1-2.5-10.3 5.4-25.9 108.1-26.3 229.4-1.1 121.3 25.3 215.2 66.7 209.8 92.6-.4 1.9-1.3 3.6-2.7 5.2-17.7 20.6-114.2 19.3-226.7-4.2-106.1-22-191.4-56.5-207.3-82.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon02);
export default __webpack_public_path__ + "static/media/spoon-02.5defc07a38243bbc3fbcdd2716115a13.svg";
export { ForwardRef as ReactComponent };